import React from 'react';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import TrialOutreachPill from '../../trial-outreach/components/TrialOutreachPill';
import { instagramProfileLink } from '../prospectOptions';

/**
 * PlaceResultRow - Um lugar achado no Google Maps, com a caixa para importar.
 * @param {Object} props
 * @param {Object} props.item linha de admin/prospects/search_places.php
 * @param {boolean} props.checked
 * @param {Function} props.onToggle
 */
function PlaceResultRow({ item, checked, onToggle }) {
  const inCatalog = !!item.existing_id;

  return (
    <Box
      sx={{
        display: 'flex', alignItems: 'flex-start', gap: 1, py: 1, px: 0.5,
        borderBottom: '1px solid #E8ECF0', opacity: inCatalog ? 0.6 : 1,
      }}
    >
      <Checkbox size="small" checked={checked} disabled={inCatalog} onChange={() => onToggle(item.source_ref)} sx={{ mt: -0.5 }} />

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>{item.name}</Typography>
          {inCatalog && <TrialOutreachPill tone="grey" label="Já no catálogo" />}
        </Box>
        {item.address && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>{item.address}</Typography>
        )}
        <Box sx={{ display: 'flex', flexWrap: 'wrap', columnGap: 2, rowGap: 0.25, mt: 0.5 }}>
          {item.whatsapp ? (
            <Typography variant="caption">WhatsApp {item.phone || item.whatsapp}</Typography>
          ) : item.phone && (
            <Typography variant="caption" color="text.secondary">Fixo {item.phone}</Typography>
          )}
          {item.instagram && (
            <Link href={instagramProfileLink(item.instagram)} target="_blank" rel="noopener" variant="caption" underline="hover">
              @{item.instagram}
            </Link>
          )}
          {item.email && <Typography variant="caption">{item.email}</Typography>}
          {item.website && (
            <Link href={item.website} target="_blank" rel="noopener" variant="caption" underline="hover">Site</Link>
          )}
          {item.maps_url && (
            <Link href={item.maps_url} target="_blank" rel="noopener" variant="caption" underline="hover">Maps</Link>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default PlaceResultRow;
